const majorList = [
  "Accounting",
  "Agricultural Economics",
  "Agriculture",
  "Applied Physics",
  "Architecture",
  "Astronomy",
  "Astrophysics",
  "Audiology",
  "Banking",
  "Biochemistry",
  "Bioinformatics",
  "Biology",
  "Biomedical Engineering",
  "Biophysics",
  "Biostatistics",
  "Business",
  "Business Management",
  "Career Development",
  "Chemical Engineering",
  "Chemical Physics",
  "Chemistry",
  "Chinese",
  "Cinema and Media Studies",
  "City Planning",
  "Civil Engineering",
  "Cognitive Science",
  "Communications",
  "Computational Biology",
  "Computer Engineering",
  "Computer Science",
  "Consulting",
  "Counseling",
  "Data Science",
  "Dentistry",
  "Design",
  "Earth Science",
  "Ecology",
  "Economics",
  "Education",
  "Electrical Engineering",
  "Engineering",
  "English",
  "Environmental Engineering",
  "Environmental Science",
  "Epidemiology",
  "Finance",
  "Fine Arts",
  "Genetics",
  "Geography",
  "Geological Engineering",
  "Geology",
  "Government",
  "Health",
  "History",
  "Industrial Engineering",
  "Information Sciences",
  "International Business",
  "International Finance",
  "Law",
  "Liberal Arts",
  "Management",
  "Marketing",
  "Mathematics",
  "Mathematics Education",
  "Mechanical Engineering",
  "Media Studies",
  "Medicine",
  "Microbiology",
  "Mining Engineering",
  "Molecular Biology",
  "Music",
  "Neuroscience",
  "Nuclear Engineering",
  "Nursing",
  "Nutrition",
  "Ophthalmology",
  "Organic Chemistry",
  "Orthopaedic Surgery",
  "Painting",
  "Paleontology",
  "Personal Training",
  "Petroleum Engineering",
  "Pharmacy",
  "Philosophy",
  "Philosophy of Science",
  "Physics",
  "Political Science",
  "Psychology",
  "Public Policy",
  "Radiology",
  "Real Estate",
  "Science",
  "Science Education",
  "Statistics"
];

const majorOptions = majorList.map(m => {
  return {value: m, label: m};
});

export default majorOptions;
